import { useApiClient } from '~/services/api'
import type { AgreementOpeningLookup } from '~/composables/AgreementOpeningLookup'
import type { LegalAgreementIndexQuery, LegalAgreementPage } from '~/services/api/generated'

/** Reads the caller's current (non-superseded) agreement matching the query; a failure propagates to the caller. */
export const useLegalAgreementLookup = () => {
  const legalAgreement = useApiClient().legalAgreement()

  const loadCurrentAgreement = async <A extends LegalAgreementPage['agreements'][number]>(
    query: LegalAgreementIndexQuery,
    isAgreement: (agreement: LegalAgreementPage['agreements'][number]) => agreement is A
  ): Promise<AgreementOpeningLookup<A>> => {
    const page = await legalAgreement.index(query)
    const agreement = page.agreements
      .filter(isAgreement)
      .find((candidate) => candidate.status !== 'superseded')
    return agreement === undefined ? { isFound: false } : { agreement, isFound: true }
  }

  return { loadCurrentAgreement }
}
